import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-7-small', 'Number7Small', [["path",{"d":"M10 8h4l-2 8"}]]);